<div class="container">
  <div ngbAccordion #acc="ngbAccordion" activeIds="ngb-panel-0">

    <div ngbAccordionItem id="panelConvencional" *ngIf="operacaoScr; else carregando">
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton>IPOC Convencional</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">

                        <div class="bn-form-group col-md-3">
                            <label class="form-label"><b>Data Base:</b></label>
                            <input type="text" class="form-control" name="dataBase" [ngModel]="operacaoScr.dataBase" bnMask="ANOMES"
                                disabled />
                        </div>

                        <div class="bn-form-group col-md-3">
                            <label class="form-label"><b>Data de Contratação:</b></label>
                            <input type="text" class="form-control" name="dataContrato"
                                [ngModel]="operacaoScr.dataContrato | date:'dd/MM/yyyy' " disabled />
                        </div>

                        <div class="bn-form-group col-md-3">
                            <label class="form-label"><b>Data de Vencimento:</b></label>
                            <input type="text" class="form-control" name="dataVencimento"
                                [ngModel]="operacaoScr.dataVencimento | date:'dd/MM/yyyy' " disabled />
                        </div>

                        <div class="bn-form-group col-md-3">
                            <label class="form-label"><b>Dias em atraso:</b></label>
                            <input type="text" class="form-control" name="diasAtraso" [ngModel]="operacaoScr.diasAtraso" disabled />
                        </div>

                    </div>
                    <div class="row">
                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Tipo do Cliente:</b></label>
                            <input type="text" class="form-control" name="tipoCliente" [ngModel]="operacaoScr.tipoCliente" disabled />
                        </div>

                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Valor Vincenda:</b></label>
                             <input type="text" bnMask="MOEDA" class="form-control" name="vicenda"
                                [ngModel]="operacaoScr.valorAtivaVencer" disabled />
                        </div>

                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Valor Vencida:</b></label>
                            <input type="text" bnMask="MOEDA" class="form-control" name="vencida"
                                [ngModel]="operacaoScr.valorAtivaVencida" disabled />
                        </div>

                        <div class="bn-form-group col-md-6">
                            <label class="form-label"><b>Modalidade:</b></label>
                            <input type="text" class="form-control" name="modalidade" [ngModel]="operacaoScr.modalidade" disabled />
                        </div>

                        <div class="bn-form-group col-md-6">
                            <label class="form-label"><b>Saída:</b></label>
                            <input type="text" class="form-control" name="saida" [ngModel]="operacaoScr.saida" disabled />
                        </div>

                        <div class="bn-form-group col-md-12">
                            <label class="form-label"><b>IPOC:</b></label>
                            <input type="text" class="form-control" name="ipoc" [ngModel]="operacaoScr.ipoc" disabled />
                        </div>

                    </div>
                    <div class="table-responsive mt-3">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">Tipo de Vértice</th>
                                    <th scope="col">Valor</th>
                                <tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let vertice of operacaoScr.vertices">

                                    <td>{{ formataTipoVerticeScr(vertice) }} </td>
                                    <td>{{ vertice.valorVertice | bnMask: 'MOEDA' }}</td>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem id="panelCooperativa" *ngIf="operacaoScrCooperativa; else carregando">
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton>IPOC Cooperativa</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>

                    <div class="row">

                        <div class="bn-form-group col-md-3">
                            <label class="form-label"><b>Data Base:</b></label>
                            <input type="text" class="form-control" name="dataBase" [ngModel]="operacaoScrCooperativa.dataBase"
                                bnMask="ANOMES" disabled />
                        </div>

                        <div class="bn-form-group col-md-3">
                            <label class="form-label"><b>Data de Contratação:</b></label>
                            <input type="text" class="form-control" name="dataContrato"
                                [ngModel]="operacaoScrCooperativa.dataContrato | date:'dd/MM/yyyy' " disabled />
                        </div>

                        <div class="bn-form-group col-md-3">
                            <label class="form-label"><b>Data de Vencimento:</b></label>
                            <input type="text" class="form-control" name="dataVencimento"
                                [ngModel]="operacaoScrCooperativa.dataVencimento | date:'dd/MM/yyyy' " disabled />
                        </div>

                        <div class="bn-form-group col-md-3">
                            <label class="form-label"><b>Dias em atraso:</b></label>
                            <input type="text" class="form-control" name="diasAtraso" [ngModel]="operacaoScrCooperativa.diasAtraso"
                                disabled />
                        </div>

                    </div>
                    <div class="row">
                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Tipo do Cliente:</b></label>
                            <input type="text" class="form-control" name="tipoCliente" [ngModel]="operacaoScrCooperativa.tipoCliente"
                                disabled />
                        </div>

                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Valor Vincenda:</b></label>
                            <input type="text" bnMask="DECIMAL" class="form-control" name="vicenda"
                                [ngModel]="operacaoScrCooperativa.valorAtivaVencer" disabled />
                        </div>

                        <div class="bn-form-group col-md-4">
                            <label class="form-label"><b>Valor Vencida:</b></label>
                            <input type="text" bnMask="DECIMAL" class="form-control" name="vencida"
                                [ngModel]="operacaoScrCooperativa.valorAtivaVencida" disabled />
                        </div>

                        <div class="bn-form-group col-md-6">
                            <label class="form-label"><b>Modalidade:</b></label>
                            <input type="text" class="form-control" name="modalidade" [ngModel]="operacaoScrCooperativa.modalidade"
                                disabled />
                        </div>

                        <div class="bn-form-group col-md-6">
                            <label class="form-label"><b>Saída:</b></label>
                            <input type="text" class="form-control" name="saida" [ngModel]="operacaoScrCooperativa.saida" disabled />
                        </div>

                        <div class="bn-form-group col-md-12">
                            <label class="form-label"><b>IPOC:</b></label>
                            <input type="text" class="form-control" name="ipoc" [ngModel]="operacaoScrCooperativa.ipoc" disabled />
                        </div>

                    </div>
                    <div class="table-responsive mt-3">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">Tipo de Vértice</th>
                                    <th scope="col">Valor</th>
                                <tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let vertice of operacaoScrCooperativa.vertices">

                                    <td>{{ formataTipoVerticeScr(vertice) }} </td>
                                    <td>{{ vertice.valorVertice | bnMask: 'MOEDA' }}</td>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                </ng-template>
            </div>
        </div>
    </div>

  </div>

</div>



<div class="alert alert-info" *ngIf="showMessage && showMessageCoop">
  Não foi encontrada operação SCR associada a esta operacão.
</div>

<ng-template #carregando *ngIf="!showMessage || !showMessageCoop">
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>